import { render, staticRenderFns } from "./WinnersSection.vue?vue&type=template&id=64453a47&scoped=true&"
import script from "./WinnersSection.vue?vue&type=script&lang=js&"
export * from "./WinnersSection.vue?vue&type=script&lang=js&"
import style0 from "./WinnersSection.vue?vue&type=style&index=0&id=64453a47&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64453a47",
  null
  
)

export default component.exports